// extracted by mini-css-extract-plugin
export default {"profile":"User_profile__Mw3-w","loading":"User_loading__IVQ8T","bounce":"User_bounce__dCaL1"};